export default function () {
	const body = document.querySelector('body'),
		mainMenu = document.querySelector('.js-main-menu'),
		mainMenuToggle = document.querySelector('.js-main-menu-toggle'),
		mainMenuToggleText = document.querySelector(
			'.js-main-menu-toggle-text'
		),
		mainMenuSubToggle = document.querySelectorAll(
			'.js-main-menu-sub-toggle'
		),
		menuWithSubNavs = document.querySelectorAll(
			'.main-menu .menu-item-has-children'
		),
		IS_OPEN = 'open',
		IS_CLOSED = 'closed',
		OPEN_CLASS = 'main-menu--open';

	// Main menu toggle handler and event listener
	const mainMenuToggleHandler = (event) => {
		event.preventDefault();

		if (mainMenu.getAttribute('data-menu') === IS_OPEN) {
			// Close the main menu
			body.classList.remove(OPEN_CLASS);
			mainMenu.setAttribute('data-menu', IS_CLOSED);
			mainMenu.removeAttribute('aria-expanded');
			mainMenuToggle.setAttribute('data-menu', IS_CLOSED);
			mainMenuToggleText.innerHTML = 'Open Main Menu';
		} else {
			// Open the main menu
			body.classList.add(OPEN_CLASS);
			mainMenu.setAttribute('data-menu', IS_OPEN);
			mainMenu.setAttribute('aria-expanded', 'true');
			mainMenuToggle.setAttribute('data-menu', IS_OPEN);
			mainMenuToggleText.innerHTML = 'Close Main Menu';
		}
	};

	if (mainMenuToggle) {
		mainMenuToggle.addEventListener('click', mainMenuToggleHandler);
	}

	// Main Menu sub toggle event listener
	if (mainMenuSubToggle.length) {
		mainMenuSubToggle.forEach((toggle) => {
			const subMenu = toggle.nextElementSibling;
			subMenu.setAttribute('aria-hidden', 'true');

			toggle.addEventListener('click', () => {
				toggle.setAttribute(
					'aria-expanded',
					toggle.getAttribute('aria-expanded') === 'true'
						? false
						: true
				);
				subMenu.setAttribute(
					'aria-hidden',
					subMenu.getAttribute('aria-hidden') === 'true'
						? false
						: true
				);
			});
		});
	}

	// Functions for handling mouse enter and leave and the submenus.
	const menuEnterHandler = (event) => {
		const toggle = event.currentTarget.querySelector(
				'.js-main-menu-sub-toggle'
			),
			subMenu = event.currentTarget.querySelector('.sub-menu');
		toggle.setAttribute('aria-expanded', 'true');
		subMenu.setAttribute('aria-hidden', 'false');
	};

	const menuLeaveHandler = (event) => {
		const toggle = event.currentTarget.querySelector(
				'.js-main-menu-sub-toggle'
			),
			subMenu = event.currentTarget.querySelector('.sub-menu');
		toggle.setAttribute('aria-expanded', 'false');
		subMenu.setAttribute('aria-hidden', 'true');
	};

	const initDesktopFunctions = () => {
		menuWithSubNavs.forEach((menu) => {
			menu.addEventListener('mouseenter', menuEnterHandler);
			menu.addEventListener('mouseleave', menuLeaveHandler);
		});
	};

	const destroyDesktopFunctions = () => {
		menuWithSubNavs.forEach((menu) => {
			menu.removeEventListener('mouseenter', menuEnterHandler);
			menu.removeEventListener('mouseleave', menuLeaveHandler);
		});
	};

	const mediaQuery = '(min-width: 64.1rem)';
	const mediaQueryList = window.matchMedia(mediaQuery);

	if (mediaQueryList.matches) {
		initDesktopFunctions();
	} else {
		destroyDesktopFunctions();
	}

	mediaQueryList.addEventListener('change', (event) => {
		if (event.matches) {
			initDesktopFunctions();
		} else {
			destroyDesktopFunctions();
		}
	});
}
